import { DoorOpen, ShieldCheck, BookLock } from "lucide-react";

const STEPS = [
  [DoorOpen, "The Agent List sensor sits at your gateway", "Our DS-1 box becomes the building's network gateway. The operating system forwards traffic as usual while the sensor reads a filtered copy, so the network never slows down."],
  [ShieldCheck, "It checks every AI agent, in and out", "It sees which AI services each part of the network uses, such as ChatGPT, Copilot, Claude or Gemini, and which outside agents reach your on-site systems. Origins are checked against the addresses OpenAI, Anthropic, Google, Perplexity and others publish."],
  [BookLock, "It writes it in the agent list", "Each arrival goes into a chained, tamper-evident list anchored to Bitcoin: which agent, which network area, and when. You can search it, filter it and export it for audits."],
];

export const HowItWorks = () => (
  <section id="how" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 scroll-mt-16" data-testid="landing-how">
    <p className="font-mono text-xs text-emerald-400 tracking-[0.3em] uppercase">How it works</p>
    <h2 className="text-2xl sm:text-3xl font-semibold text-slate-50 mt-3 max-w-2xl">It greets every AI agent, checks its ID and keeps the list.</h2>
    <div className="grid md:grid-cols-3 gap-6 mt-14">
      {STEPS.map(([Icon, title, body], i) => (
        <div key={title} className="rounded-md border border-[#222D3D] bg-[#141A24] p-6 hover:border-slate-600 transition-colors">
          <div className="flex items-center justify-between">
            <Icon className="h-6 w-6 text-emerald-400" />
            <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
          </div>
          <h3 className="text-lg font-semibold text-slate-100 mt-6">{title}</h3>
          <p className="text-sm text-slate-400 mt-2 leading-relaxed">{body}</p>
        </div>
      ))}
    </div>
  </section>
);
